<template>
  <div class="view">
    <h2 class="ui inverted header">Reset password</h2>
    <div class="">
      <sui-message size="large">
        A reset link has been sent to your email address.<br>
        Open it up to set a new password.
      </sui-message>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AccountRecoveryStart'
  }
</script>

<style scoped>
  .view { display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; }
</style>
